"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TextField = _interopRequireDefault(require("./TextField"));

var _SelectField = _interopRequireDefault(require("./SelectField"));

var _TextAreaField = _interopRequireDefault(require("./TextAreaField"));

var _RadioButtonField = _interopRequireDefault(require("./RadioButtonField"));

var _CheckboxField = _interopRequireDefault(require("./CheckboxField"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const fieldMap = {
  text: _TextField.default,
  select: _SelectField.default,
  textarea: _TextAreaField.default,
  radio: _RadioButtonField.default,
  checkbox: _CheckboxField.default
};

function Field({
  fields,
  formikProps
}) {
  const {
    errors,
    values,
    handleChange,
    setFieldValue
  } = formikProps;
  return fields.map((item, index) => {
    const Component = fieldMap[item.type];
    let error = errors.hasOwnProperty(item.id) && errors[item.id];

    if (!item.type) {
      return null;
    }

    return _react.default.createElement(Component, {
      key: index,
      label: item.label,
      name: item.id,
      placeholder: item.placeholder,
      value: values[item.id],
      options: item.options,
      onChange: handleChange,
      setFieldValue: setFieldValue,
      error: error
    });
  });
}

Field.propTypes = {
  fields: _propTypes.default.array.isRequired,
  formikProps: _propTypes.default.object.isRequired
};
var _default = Field;
exports.default = _default;